import * as React from 'react';
export const spinnerSvg = React.forwardRef(function spinnerSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 .125c.483 0 .875.392.875.875v2a.875.875 0 1 1-1.75 0V1c0-.483.392-.875.875-.875ZM3.55 2.312A.875.875 0 1 0 2.312 3.55l1.366 1.365a.875.875 0 1 0 1.237-1.237L3.55 2.312ZM.125 8c0-.483.392-.875.875-.875h2a.875.875 0 1 1 0 1.75H1A.875.875 0 0 1 .125 8Zm12 0c0-.483.392-.875.875-.875h2a.875.875 0 0 1 0 1.75h-2A.875.875 0 0 1 12.125 8Zm-9.813 4.45a.875.875 0 0 0 1.238 1.238l1.365-1.366a.875.875 0 1 0-1.237-1.237L2.312 12.45Zm11.376 1.238a.875.875 0 0 1-1.238 0l-1.365-1.366a.875.875 0 1 1 1.237-1.237l1.366 1.365a.875.875 0 0 1 0 1.238ZM8.875 13a.875.875 0 0 0-1.75 0v2a.875.875 0 0 0 1.75 0v-2Z',
    }),
  );
});
spinnerSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var spinner = {
  category: 'icon',
  colorable: true,
  name: 'spinner',
  svg: spinnerSvg,
};
